<template>
  <div>
    <v-row align="center" class="large-indent--top">
      <v-col align-self="center"
       xs="12"
       sm="6"
       md="6"
       lg="6">
        <h1 class="large-indent__h1">
          Получите кэшбэк 1&nbsp;111&nbsp;&#x20bd;
        </h1>
        <div class="large-indent__slogan mt-4">
          <span>
          Сканируйте QR-коды и получайте повышенный кэшбэк за покупки по карте «Халва» в счастливые часы
          </span>
          <br>
          Нет карты? <a target="_blank" href="https://halvacard.ru/order/?utm_medium=Partner&utm_source=vsemirnyydenshopinga&utm_campaign=2024">Оформите&nbsp;сейчас</a>
        </div>
      </v-col>
      <v-col align-self="start" :max-width="$vuetify.breakpoint.mdOnly ? '50%' : '100%'"
       xs="12"
       sm="6"
       md="6"
       lg="6">
        <v-img
          :src="require('../assets/img/happy_hours@2x.png')"
          contain
        ></v-img>
      </v-col>
      <v-col align-self="start"
       sm="6"
       md="6"
       lg="6">
        <div class="btn-box" :class="buttonMarginClass">
          <div class="btn btn--red btn-text d-flex justify-content-center" @click="showStepper = !showStepper">
            <div class="btn-icon">
              <v-img
                :src="require('../assets/img/svg/qr-code.svg')"
                height="21"
                width="22"
                contain
                style="margin-right: 10px;"
              ></v-img>
              <!--v-icon dark style="margin-right: 10px;">mdi-qrcode-scan</v-icon-->
              <span>Отсканировать чек</span>
            </div>
          </div>
          <div class="btn btn--gray btn-text" @click="showSlider = !showSlider">Результаты проверки</div>
        </div>
      </v-col>
    </v-row>

    <v-row class="large-indent">
      <v-col>
        <h2 class="large-indent__h2">Как это работает</h2>
        <v-row class="block-box">
          <v-col v-for="(block, id) in blocks[$router.currentRoute.name]" :key="id" cols="12" sm="6" md="6" lg="3" class="block-box__item d-flex align-stretch">
            <description-block
              :block-name="block.name || 'Шаг '+ (id + 1)"
              :block-title="block.title"
              :block-class="block.class"
              :block-img="require('@/assets/img/'+block.img)"
            >
              <a
                v-if="block.slot && block.slot.href"
                :target="block.slot.target"
                :href="block.slot.href"
                :class="block.slot.class"
              >
                {{ block.slot.title }}
              </a>
              <div
                v-else-if="block.slot"
                :class="block.slot.class + ' grey--text text--lighten-1'"
              >
                {{ block.slot.title }}
              </div>
            </description-block>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="large-indent">
      <v-col>
        <h2 class="large-indent__h2">
          <span class="text-pink">Лайфхаки</span> от «Халвы»
        </h2>
        <v-row class="panel-box">
          <v-expansion-panels style="z-index: unset;">
            <panel v-for="(panel, id) in panels" :key="id"
              :panel-title="panel.title"
              :panel-description="panel.description"
              :panel-contents="panel.contents[$router.currentRoute.name]"
            />
          </v-expansion-panels>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="large-indent">
      <v-col>
        <h2 class="large-indent__h2">
          <div class="text-center">
            Если у вас остались вопросы пишите <br>на почту <a :href="'mailto:' + contactEmail[$router.currentRoute.name]">{{ contactEmail[$router.currentRoute.name] }}</a>
          </div>
        </h2>
        <v-row justify="center">
            <a target="_blank" :href="links[$router.currentRoute.name]" class="btn btn--gray btn-text">подробнее об акции</a>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog
      v-model="showStepper"
      persistent
      max-width="500px"
      scrollable
    >
      <v-card>
        <v-card-title>
          <v-row>
            <div class="flex-grow-1">
              <h2 class="headline">Сканирование</h2>
              <h5>отсканируйте QR-код с чека</h5>
            </div>
            <v-btn
              class="mx-2"
              color="#ff4e50"
              fab small dark
              @click="showStepper = false"
            >
              <v-icon dark>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text class="px-0 pb-0">
          <loader
            :loadingStepper="loadingStepper"
          >
            <stepper
              :campaignsList="campaignsList"
              :statusesList="statusesList"
              type="stepper"
              :steps="stepperSteps"
              @closeStepper="showStepper = false" />
          </loader>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showSlider"
      persistent
      max-width="500px"
      scrollable
    >
      <v-card>
        <v-card-title>
          <v-row>
            <div class="flex-grow-1">
              <h2 class="headline">Результаты проверки</h2>
              <h5>по отсканированным чекам</h5>
            </div>
            <v-btn
              class="mx-2"
              color="#ff4e50"
              fab small dark
              @click="showSlider = false"
            >
              <v-icon dark>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text class="px-0 pb-0">
          <loader
            :loadingStepper="loadingStepper"
          >
            <stepper
              :campaignsList="campaignsList"
              :statusesList="statusesList"
              type="slider"
              :steps="sliderSteps"
              @closeStepper="showSlider = false" />
          </loader>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import descriptionBlock from '@/components/DescriptionBlock'
import panel from '@/components/Panel'
import stepper from '@/components/Stepper'
import loader from '@/components/utils/loader'

import {
  map
} from 'lodash'

export default {
  components: {
    descriptionBlock,
    panel,
    stepper,
    loader
  },

  data: () => ({
    loadingStepper: false,

    campaignsList: [],
    statusesList: [],

    showStepper: false,
    stepperSteps: [
      { headline: 'Введите Ваш телефон' },
      { headline: 'Наведите камеру на QR-код' },
      { headline: 'Ручной ввод' },
      { headline: 'Результат' }
    ],

    showSlider: false,
    sliderSteps: [
      { headline: 'Ваш телефон' },
      { headline: 'Результаты' }
    ],

    contactEmail: {
      'happy_hours': 'halvacheck@sovcombank.ru'
    },

    blocks: {
      'happy_hours': [
        {
          title: 'Совершите покупку в рассрочку от 11&nbsp;000 &#x20bd; с 11 по 13 ноября в период с 08:00 до 11:00',
          img: 'hh_block_1.png',
          slot: {
            target: '_blank',
            href: 'https://halvacard.ru/shops/special',
            class: 'block__slot',
            title: 'Полный список партнеров'
          }
        },
        {
          title: 'Отсканируйте QR-код с чека. Время покупки должно совпадать со временем из Шага&nbsp;1',
          img: 'hh_block_2.png',
          slot: {
            target: '_self',
            href: '#',
            class: 'block__slot',
            title: 'Отсканировать чек'
          }
        },
        {
          title: 'Проверьте промокод в разделе «Предложения» личного кабинета на halvacard.ru или в мобильном приложении «Халва-Совкомбанк»',
          img: 'hh_block_3.png'
        },
        {
          title: 'Примените промокод к покупке и получите кэшбэк 1&nbsp;111&nbsp;баллов.',
          class: 'block--last',
          img: 'hh_block_4.png',
          slot: {
            title: '1 балл = 1 рубль',
            class: 'block__slot',
          },
        }
      ]
    },

    panels: [
      {
        title: 'Сократите время на проверку чека',
        description: 'Чтобы чек прошел проверку:',
        contents: {
          'happy_hours': [
            'QR-код на чеке должен быть отсканирован полностью, под прямым углом, при хорошем освещении.',
            'Дата на чеке должна совпадать с периодом проведения акции. Если чек выдан раньше даты начала или позже даты окончания акции, то он будет отклонен.',
            'QR-код не должен быть помят или надорван, если QR-код надорван, введите данные с чека вручную.',
            'Используйте функционал сканирования чеков, все что потребуется это предоставить доступ к камере. Если вы используете стационарный компьютер или заблокировали доступ к камере,\n' +
            'то всегда можно воспользоваться ручным вводом информации с чека. Просто нажмите кнопку "Заполнить руками".',
            'Время покупки в чеке должно совпадать с условиями, прописанными в акции. Покупки, совершенные вне указанного времени будут отклонены.',
          ]
        }
      },
      {
        title: 'Экономьте ваше время',
        contents: {
          'happy_hours': [
            'Не сканируйте QR-коды с чеков, которые оплачены не картой «Халва». Такие чеки не пройдут проверку.'
          ]
        }
      },
      {
        title: 'Указывайте корректный номер телефона',
        contents: {
          'happy_hours': [
            'Именно по этому номеру телефона будет проверяться наличие карты «ХАЛВА» и по нему предактивируется промокод в разделе «Предложения» мобильного приложения «Халва-Совкомбанк» или «Предложения для вас» в личном кабинете на <a target="_blank" href="https://halvacard.ru/">halvacard.ru</a>'
          ]
        }
      },
      {
        title: 'Обязательно сохраните номер чека',
        contents: {
          'happy_hours': [
            'После сканирования ваш чек будет принят в обработку. Актуальный статус по проверке чека можно посмотреть нажав кнопку «УЗНАТЬ РЕЗУЛЬТАТ ПРОВЕРКИ», которая находится правее кнопки «Отсканировать QR-код чека».'
          ]
        }
      },
      {
        title: 'Активируйте промокод сразу после получения',
        contents: {
          'happy_hours': [
            'После успешной проверки чека промокод появится в разделе «Предложения» мобильного приложения «Халва-Совкомбанк» или «Предложения для вас» в личном кабинете на <a target="_blank" href="https://halvacard.ru/">halvacard.ru</a>'
          ]
        }
      }
    ],

    links: {
      'happy_hours': 'https://halvacard.ru/shops/actions/11-11-vsemirnyj-den-shopinga',
    }
  }),

  computed: {
    buttonMarginClass () {
      switch (this.$vuetify.breakpoint.name) {
        default:
        case 'xs': return 'btn-box--xsAndDown'
        case 'sm': return 'btn-box--xsAndDown'
        case 'md': return 'btn-box--md'
        case 'lg': return 'btn-box--lgAndUp'
        case 'xl': return 'btn-box--lgAndUp'
      }
    }
  },

  methods: {
    initLists () {
      this.loadingStepper = true

      Promise.all([
        api.getCampaignsList({ active: true }).request,
        api.getStatusesList().request
      ]).then(response => {
        this.campaignsList = map(response[0].data, item => ({ value: item.id, text: item.title, route: item.route }))
        this.statusesList = response[1].data
        this.loadingStepper = false
      }).catch(error => {
        this.$snackBar.show(error.message)
      })
    }
  },

  mounted () {
    this.initLists()
  }
}
</script>

<style lang="scss">
  .block__title {
    color: #714141;
    font-size: 16px;
    font-family: proxima_nova_rgbold, sans-serif;
    letter-spacing: -.1px;
    margin-bottom: 40px;
    font-weight: 600;
  }

  .block--last .block__title {
    margin-bottom: 40px;
  }

  .large-indent {
    padding-bottom: 50px;
    @media (min-width: 768px) {
      padding-bottom: 60px;
    }
    @media (min-width: 992px) {
      padding-bottom: 120px;
    }

    &--top {
      padding-top: 50px;
      @media (min-width: 768px) {
        padding-top: 60px;
      }
      @media (min-width: 992px) {
        padding-top: 120px;
      }
    }

    &__h1 {
      color: black;
      font-family: proxima_nova_rgbold, sans-serif;
      margin-bottom: 8px;
      text-align: left;
      line-height: 1;

      span {
        color: #ff5d5f;
        display: block;
      }

      @media (min-width: 768px) {
        font-size: 30px;
      }

      @media (max-width: 767px) {
        font-size: 1.6rem;
      }
    }

    &__h2 {
      color: #714141;
      font-family: proxima_nova_rgbold;
      font-size: 28px;
      line-height: 1.3;
      text-align: center;
      padding-bottom: 30px;

      @media (min-width: 768px) {
        text-align: left;
      }
    }

    &__slogan {
      font-size: 18px;
      line-height: 24px;
      margin-bottom: 32px;
      color: #734343;
      text-align: left;

      span {
        font-family: proxima_nova_rgbold;
      }

      @media (min-width: 768px) {
        text-align: left;
      }

    }

    &__img-decorate {
      margin: -80px -60px 30px -60px;
      pointer-events: none;

      img {
        margin: 0 auto;
      }

      @media (min-width: 768px) {
        margin: 0;
        position: absolute;
        top: -75px;
        transform: translateX(100%);
      }
    }
  }

  .block-box {
    @media (min-width: 992px) {
      padding-top: 60px;
    }

    &__item {
      @media (min-width: 992px) {
        flex: 0 0 25%;
      }
    }
  }

  .panel-box {
    margin-right: 0;
    margin-left: 0;
  }

  .btn-box {

    .btn {
      margin-bottom: 16px;
      display: block;
      text-align: center;
      padding: 12px 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &--xsAndDown {
      margin-top: 0;
    }

    &--md {
      margin-top: -40px;
    }

    &--lgAndUp {
      margin-top: -80px;
    }

    @media (min-width: 992px) {
      display: flex;
      .btn {
        flex-grow: 1;
        margin-bottom: 0;

        &:first-child {
          margin-right: 10px;
        }

        &:last-child {
          margin-left: 10px;
        }
      }

      &--md {
        margin-top: -170px;
      }

      &--lgAndUp {
        margin-top: -100px;
      }
    }
  }
</style>
